module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "wide": false,
      "width": "800px",
      "show-close": false
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(_vm.currentPaymentState == 'before-and-during-payment') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.before-and-during-payment--skirental')))]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'syncing') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.syncing')))]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'error') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.error')))]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'error-on-sync') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.error-on-sync')))]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'success') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.success')))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "handler"
  }), _vm._v(" "), (_vm.currentPaymentState == 'before-and-during-payment') ? _c('h2', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t('general.payment.to-pay')) + ":   "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.sum)))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'before-and-during-payment') ? _c('p', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'before-and-during-payment') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('img', {
    staticClass: "pulsing",
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/kortterminal.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.insert-card-instructions')))]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), (!_vm.canCancel) ? _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.cancel-instructions'))), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "white border",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.localCloseModal(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.cancel')))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'syncing') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('general.payment.syncing')))]), _vm._v(" "), _c('CreatingOrder', {
    attrs: {
      "method": "chip",
      "hash": _vm.hash,
      "show-texts": false,
      "do-redirect": false
    },
    on: {
      "callback": _vm.onSyncCallback
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'error') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/error.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.messages[0].message))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'error-on-sync') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/error.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.sync-error')))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'success') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/kortterminal-check.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.synced-remember-reciept')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.your-order-number')) + ":")]), _vm._v(" "), _c('p', {
    staticClass: "order-number"
  }, [_vm._v(_vm._s(_vm.orderNumber))]), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v(_vm._s(_vm.$t('general.payment.closing', {
    seconds: 10
  })))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState === 'error') ? _c('div', {
    staticClass: "center"
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.resetPayment()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.try-again')))]), _vm._v(" "), _c('button', {
    staticClass: "white",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.cancel-booking')))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState === 'error-on-sync') ? _c('div', {
    staticClass: "center"
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.createOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.try-again')))])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', _vm._l((_vm.messages), function(ref) {
    var message = ref.message;

    return _c('p', [_vm._v(_vm._s(message))])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.$store.state.isDebugging) ? _c('div', {
    staticClass: "debugging"
  }, [_vm._v("\n    Simulera:\n    "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.simulateTerminalInsert()
      }
    }
  }, [_vm._v("Sätt i kort")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.simulateTerminalCode()
      }
    }
  }, [_vm._v("Ange kod")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.simulateTerminalApprove()
      }
    }
  }, [_vm._v("Godkänn")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.simulateTerminalCancel()
      }
    }
  }, [_vm._v("Avbryt")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fac6ed4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/OnSitePayment.vue
// module id = 969
// module chunks = 0